import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import * as Dati from "../../../Dati";
import { Trad } from "../../../components/";
import { _Dropzone, _ButtonAPI } from "../../components";

interface IBondDataProps {
    Data: Dati.CRisAPI_DatiPolizzaCodiceControllo;
}

export const _BondData: React.FC<IBondDataProps> = ({ Data }) => {
    return (
        <Card>
            <CardHeader title={Trad.Trad("Dati Fideiussione")} titleTypographyProps={{ variant: "h6" }} />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={6} md={3}>
                        <Typography variant="body1" color="inherit">
                            {Trad.Trad("Codice controllo")}:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={9}>
                        <Typography variant="body1" color="inherit">
                            {Data.CodiceControllo}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography variant="body1" color="inherit">
                            {Trad.Trad("Polizza")}:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={9}>
                        <Typography variant="body1" color="inherit">
                            {Data.Polizza}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography variant="body1" color="inherit">
                            {Trad.Trad("Contraente")}:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={9}>
                        <Typography variant="body1" color="inherit">
                            {Data.Contraente}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography variant="body1" color="inherit">
                            {Trad.Trad("Beneficiario")}:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={9}>
                        <Typography variant="body1" color="inherit">
                            {Data.Beneficiario}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography variant="body1" color="inherit">
                            {Trad.Trad("Importo garantito")}:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={9}>
                        <Typography variant="body1" color="inherit">
                            {Data.ImportoGarantito}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography variant="body1" color="inherit">
                            {Trad.Trad("Data emissione")}:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={9}>
                        <Typography variant="body1" color="inherit">
                            {Trad.TradParam("{1-D}", [Data.DataEmissione])}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondCheckCode/BondData.tsx